<template>
  <div class="page">
    <HorizontalScroll>
        <div class="list1">
            <div class="item1" v-for="(item,index) in list1" :key="index" :class="current_cid1==item.id?'hover1':''" @click="changeTab1(item)">{{item.title}}</div>
        </div>
    </HorizontalScroll>
    <div class="box">
        <div class="list2">
            <div class="item2" :class="current_cid2?'':'hover2'" @click="getAll()">全部</div>
            <div class="item2" v-for="(item,index) in list2" :key="index" :class="current_cid2==item.id?'hover2':''" @click="changeTab2(item)">{{item.title}}</div>
        </div>
        <div class="list3">
            <div class="item3" v-for="(item,index) in list3" :key="index" @click="goDetail(item.id)">
                <img class="img" :src="cdnUrl+item.img[0]" alt="">
                <div class="info">
                    <div class="name">{{item.title}}</div>
                    <button class="btn">了解更多</button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import HorizontalScroll from '@/components/HorizontalScroll.vue';
import { getProCate } from '@/api/centrifuge'
import { getRotorList } from '@/api/rotor'

export default {
  components: {
    HorizontalScroll
  },
  data() {
    return {
      cdnUrl: this.$config.baseUrl.cdnUrl,
      list1:[],
      list2:[],
      list3:[],
      current_cid1:'',
      current_cid2:'',
    }
  },
  created() {
    this.getCategoryList()
  },
  methods: {
    changeTab1(item){
        this.current_cid1 = item.id
        this.current_cid2 = ''
        this.list2 = item.children
        this.getList()
    },
    changeTab2(item){
        this.current_cid2 = item.id
        this.getList()
    },
    getAll(){
        this.current_cid2 = ''
        this.getList()
    },
    getCategoryList(){
        getProCate({type:11}).then(res => {
            this.list1 = res
            this.current_cid1 = res[0].id
            this.list2 = res[0].children
            this.getList()
        })
    },
    getList(){
        var para={
            category_id:this.current_cid2||this.current_cid1,
            size:100
        }
        getRotorList(para).then(res => {
            this.list3 = res.data.data
        })
    },
    goDetail(id){
        this.$router.push({ name: 'rotorDetail', query: { id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.page{
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;
    // display: flex;
    // flex-direction: column;
    .list1{
        width: 100%;
        height: rem(72);
        display: flex;
        align-items: center;
        overflow-x: auto;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;
        .item1{
            height: rem(40);
            line-height: rem(38);
            display: inline;
            flex-shrink: 0;
            border-radius: rem(2);
            border: rem(1) solid #6CC5DB;
            box-sizing: border-box;
            padding: 0 rem(12);
            margin-left: rem(10);
            font-size: rem(14);
            color: #6CC5DB;
            font-family: SourceHanSansSC, SourceHanSansSC;
        }
        .hover1{
            line-height: rem(40);
            font-weight: bold;
            border: unset;
            background: #6CC5DB;
            color: #FFFFFF;
        }
        .item1:last-child{
            margin-right: rem(10);
        }
    }
    .box{
        width: 100%;
        $rem: rem(72);
        height: calc(100vh - #{$rem});
        // flex: 1;
        display: flex;
        .list2{
            width: rem(105);
            $rem: rem(72);
            height: calc(100vh - #{$rem});
            background: #F5F9FC;
            padding: rem(16) rem(14);
            box-sizing: border-box;
            overflow-y: auto;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none;
            .item2{
                font-size: rem(14);
                color: #BAB7B7;
                line-height: rem(20);
                margin-bottom: rem(30);
            }
            .hover2{
                font-weight: bold;
                color: #6CC5DB;
                text-decoration: underline;
                text-decoration-thickness: rem(2);
                text-underline-offset: rem(6);
            }
        }
        .list3{
            flex: 1;
            $rem: rem(72);
            height: calc(100vh - #{$rem});
            overflow-y: auto;
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: rem(4);
            box-sizing: border-box;
            .item3{
                width: rem(236);
                height: rem(97);
                background: #FFFFFF;
                box-shadow: 0px rem(2) rem(9) 0px rgba(21,107,123,0.27);
                border-radius: rem(4);
                margin-bottom: rem(16);
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-shrink: 0;
                .img{
                    width: rem(97);
                    height: rem(63);
                    object-fit: cover;
                    margin-left: rem(8);
                    flex-shrink: 0;
                }
                .info{
                    flex: 1;
                    height: rem(63);
                    padding: 0 rem(10);
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;
                    .name{
                        width: rem(110);
                        text-align: center;
                        font-size: rem(14);
                        color: #000000;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                    .btn{
                        width: rem(76);
                        height: rem(26);
                        margin-top: rem(10);
                        border-radius: rem(2);
                        border: rem(1) solid #6CC5DB;
                        background: #FFFFFF;
                        font-size: rem(12);
                        color: #6CC5DB;
                    }
                }
            }
        }
    }
}
</style>